import { Breadcrumb, Button, notification, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import LeftMenu from "../components/menu";
import TopMenu from "../components/top-menu";
import { applicationService, mediaService } from "../api";
import {
  CheckOutlined,
  CopyOutlined,
  FileOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  LoadingOutlined,
  PlusOutlined,
  StopOutlined,
} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

const UserPage = () => {
  const [api, contextHolder] = notification.useNotification();
  const [current, setCurrent] = useState<any>();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");

  const id = window.location.pathname.split("/")[3];

  useEffect(() => {
    getCurrentApp();
  }, []);

  const paramsRejected = {
    status: "rejected",
    moderator_comment: comment,
  };

  const cancelApp = () => {
    applicationService
    .patchModerCorrectionApplication(id, paramsRejected)
    .then((resp) => {
      if (resp.statusCode) {
        error(resp.body);
      } else {
        getCurrentApp();
      }
    })
    .catch((err) => {
      console.log(err);
    });
  };

  const paramsApproved = {
    status: "approved",
    moderator_comment: comment,
  };

  const approvedApp = () => {
    applicationService
    .patchModerCorrectionApplication(id, paramsApproved)
    .then((resp) => {
      if (resp.statusCode) {
        error(resp.body);
      } else {
        getCurrentApp();
      }
    })
    .catch((err) => {
      console.log(err);
    });
  };

  const getCurrentApp = () => {
    setLoading(true);
    applicationService
      .getModerCorrectionApplication(id)
      .then((resp) => {
        if (resp.statusCode) {
          error(resp.body);
        } else {
          setCurrent(resp);
          setLoading(false);
          setComment(resp?.moderator_comment)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const error = (err: any) => {
    for (let key in err) {
      api.open({
        type: "error",
        message: "Ошибка!",
        description: err[key],
      });
    }
  };

  const uploadMedia = (url: string) => {
    setLoading(true);
    mediaService
      .getMedia(url)
      .then((resp) => {
        /*const blob = new Blob([resp], { type: "application/pdf" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = url.split("/")[6];
        a.click();
        if (url.slice(-4) == ".pdf") {*/
        const blob = new Blob([resp], {
          type: `${
            url.slice(-5) == ".jpeg" || url.slice(-4) == ".jpg"
              ? "image/jpeg"
              : url.slice(-4) == ".png"
              ? "image/png"
              : "application/pdf"
          }`,
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.target = "_blank";
        link.click();
        document.body.appendChild(link);
        //URL.revokeObjectURL(link.href);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getStatus = (a: any) => {
    switch (a) {
      case "draft":
        return (
          <>
            <CopyOutlined /> Черновик
          </>
        );
        break;
      case "moderation":
        return (
          <>
            <FileSearchOutlined /> Зарегистрирована
          </>
        );
        break;
      case "approved":
        return (
          <>
            <CheckOutlined /> Выполнена
          </>
        );
        break;
      case "rejected":
        return (
          <>
            <StopOutlined /> Отклонена
          </>
        );
        break;
      default:
        return "Нет таких значений";
    }
  };

  return (
    <div className="flex flex-start">
      {contextHolder}
      <LeftMenu />
      <TopMenu />

      {loading ? (
        <div className="page-loading">
          <Spin indicator={antIcon} />
        </div>
      ) : (
        <div className="box">
          <div className="header">
            {" "}
            <Breadcrumb
              items={[
                {
                  title: "Главная страница",
                },
                {
                  title: "Пользователи",
                },
                {
                  title: `Профиль пользователя ${id}`,
                },
              ]}
            />
            <h3>Профиль пользователя</h3>
          </div>
          <div className="flex-container">
            <div className="application-blocks right-page-block">
              <div className="white-block">
                <div className="grey-title">
                  <h3>Комментарий от администратора </h3>
                </div>
                <div className="white-block-content">

                      <TextArea
                        rows={3}
                        value={comment}
                        onChange={(evt) => setComment(evt.target.value)}
                        disabled={current?.status != "moderation"}
                      />

                </div>
              </div>
            </div>
            {current?.status == "moderation" ? (
              <div className="application-blocks left-page-block">
                <div className="white-block ">
                  <div className="grey-title">
                    <h3>Действия по заявке </h3>
                  </div>
                  <div className="white-block-content">
                    <Button
                      type="primary"
                      onClick={() => approvedApp()}
                      style={{ width: "100%" }}
                    >
                      Одобрить
                    </Button>
                    <p></p>
                    <Button
                      onClick={() => cancelApp()}
                      style={{ width: "100%" }}
                    >
                      Отклонить
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="application-blocks left-page-block">
                <div className="white-block ">
                  <div className="grey-title">
                    <h3>История изменений </h3>
                  </div>
                  <div className="white-block-content">
                    <div>{getStatus(current?.status)}</div>
                    <div className="date-string">
                      {new Date(current?.updated_at).toLocaleDateString(
                        "ru-Ru"
                      ) +
                        " " +
                        new Date(current?.updated_at).toLocaleTimeString(
                          "ru-Ru"
                        )}
                    </div>
                    <div>
                      <PlusOutlined /> Сформирована
                    </div>
                    <div className="date-string">
                      {new Date(current?.created_at).toLocaleDateString(
                        "ru-Ru"
                      ) +
                        " " +
                        new Date(current?.created_at).toLocaleTimeString(
                          "ru-Ru"
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex-container">
            <div className="application-blocks right-page-block">
              <div className="white-block">
                <div className="grey-title">
                  <h3>Документы</h3>
                </div>
                <div className="white-block-content">
                  <p className="lable grey"> Файл скана заявки с подписью</p>
                  <a
                    className="decoration"
                    onClick={() => uploadMedia(current?.signed_document)}
                  >
                    <FileOutlined /> {current?.signed_document}
                  </a>
                  {current?.signed_sig_document && (
                    <>
                      <p className="lable grey"> Файл с подписью *</p>
                      <a
                        className="decoration"
                        onClick={() => uploadMedia(current?.signed_sig_document)}
                      >
                        <FileProtectOutlined /> {current?.signed_sig_document}
                      </a>

                      <div className="small">
                        * - для{" "}
                        <a
                          href="https://www.gosuslugi.ru/pgu/eds/#type3"
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          title="Перейти к проверке подписи"
                        >
                          подтверждение подлинности электронной подписи
                        </a>{" "}
                        во вкладке "ЭП — отсоединенная, в формате PKCS#7" нужно
                        загрузить скаченный файл заявления в формате .pdf и файл
                        со сгенерированной подписью в кодировке UTF-8 с
                        расширением *.p7s
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {current?.status == "moderation" && (
              <div className="application-blocks left-page-block">
                <div className="white-block ">
                  <div className="grey-title">
                    <h3>История изменений </h3>
                  </div>
                  <div className="white-block-content">
                    <div>{getStatus(current?.status)}</div>
                    <div className="date-string">
                      {new Date(current?.updated_at).toLocaleDateString(
                        "ru-Ru"
                      ) +
                        " " +
                        new Date(current?.updated_at).toLocaleTimeString(
                          "ru-Ru"
                        )}
                    </div>
                    <div>
                      <PlusOutlined /> Сформирована
                    </div>
                    <div className="date-string">
                      {new Date(current?.created_at).toLocaleDateString(
                        "ru-Ru"
                      ) +
                        " " +
                        new Date(current?.created_at).toLocaleTimeString(
                          "ru-Ru"
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="white-block">
            <div className="grey-title">
              <h3>Содержание заявки </h3>
            </div>
            <div className="white-block-content">
              <p className="flex">
                <span className="label">Причина изменений:</span>{" "}
                <span className="tab-value">
                  {" "}
                  {current?.correction_reasons}
                </span>
              </p>
              <p className="flex">
                <span className="label">Вносимые изменения:</span>{" "}
                <span className="tab-value">
                  {" "}
                  {current?.correction_description}
                </span>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default UserPage;
